import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateUserRequest } from '../../api/create-user/createUser.types';
import type { User } from '../../api/types/user.types';
import type {
  UseCreateUserParams,
  UseCreateUserResult,
} from './useCreateUser.types';

import { createUser } from '../../api/create-user/createUser';

export function useCreateUser(
  params: UseCreateUserParams
): UseCreateUserResult {
  const queryClient = useQueryClient();

  return useMutation<User, Error, CreateUserRequest>({
    mutationFn: (data: CreateUserRequest): Promise<User> =>
      createUser(params.organizationId, data),
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
